import React from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { useNavigate } from 'react-router-dom';
import { FaExclamationTriangle, FaArrowRight } from 'react-icons/fa';
import { useLanguage } from '../../contexts/LanguageContext';

const FailedInvoicesAlert = ({ count }) => {
  const { t } = useLanguage();
  const navigate = useNavigate();
  const n = Number(count) || 0;

  return (
    <AnimatePresence>
      {n > 0 && (
        <motion.div
          initial={{ opacity: 0, y: -8 }}
          animate={{ opacity: 1, y: 0 }}
          exit={{ opacity: 0, y: -8 }}
          className="mb-6 bg-red-50 border border-red-200 rounded-xl px-4 py-3 flex items-center gap-3"
        >
          <div className="p-2 rounded-lg bg-red-100">
            <FaExclamationTriangle className="h-4 w-4 text-red-600" />
          </div>
          <p className="flex-1 text-sm font-medium text-red-800">
            {t(
              n === 1
                ? 'dashboard.failedInvoicesAlert.messageOne'
                : 'dashboard.failedInvoicesAlert.messageMany',
              { count: n }
            )}
          </p>
          <button
            onClick={() => navigate('/orders')}
            className="inline-flex items-center gap-1.5 text-sm font-medium text-red-700 hover:text-red-900 px-3 py-1.5 rounded-md hover:bg-red-100 transition-colors"
          >
            {t('dashboard.failedInvoicesAlert.action')}
            <FaArrowRight className="text-[10px]" />
          </button>
        </motion.div>
      )}
    </AnimatePresence>
  );
};

export default FailedInvoicesAlert;
